// Bilingual dictionary for ChambaNow.
// English is bundled eagerly; Spanish is lazy-loaded from ./i18n.es.js to keep
// the entry bundle small for the default (English) visitor.
// Bilingual dictionary for ChambaNow
export const translations = {
  en: {
    brand: "ChambaNow",
    common: {
      showOriginal: "Show original",
      showTranslation: "Show translation",
    },
    languages: {
      title: "LANGUAGES SPOKEN",
      subtitle: "Tap any you speak",
      filterLabel: "Speaks",
      filterAny: "Any language",
      en: "English",
      es: "Spanish",
      zh: "Mandarin",
      tl: "Tagalog",
      vi: "Vietnamese",
      ar: "Arabic",
      fr: "French",
      ht: "Haitian Creole",
      ko: "Korean",
      ru: "Russian",
      pt: "Portuguese",
      pl: "Polish",
      it: "Italian",
      hi: "Hindi",
      pa: "Punjabi",
      ur: "Urdu",
      yue: "Cantonese",
      ja: "Japanese",
      de: "German",
      fa: "Farsi",
      gu: "Gujarati",
      he: "Hebrew",
      hy: "Armenian",
      bn: "Bengali",
      el: "Greek",
    },
    nav: { search: "Find Workers", post: "Post Profile", dashboard: "Dashboard", login: "Sign In", signup: "Sign Up", logout: "Logout", inbox: "Inbox", profile: "My Profile", jobs: "Jobs", postJob: "Post a Job", myJobs: "Jobs Dashboard", myApplications: "My Applications", pricing: "Pricing", plans: "Plans & Pricing", refer: "Refer & Earn", account: "Account" },
    hero: {
      eyebrow: "BILINGUAL WORKER MARKETPLACE — CHAT AUTO-TRANSLATES",
      subtitle: "For contractors and small trade businesses who need reliable local help — post a job, browse verified workers, and chat in your own language. Every message translates instantly between English and Spanish. No middlemen, no agency fees.",
      title: "BUILT FOR HIRING LABOR WORKERS",
      titleAccent: "FAST.",
      subheading: "Built for hiring labor and trade workers — post a job free and connect with verified local pros today.",
      subheadingVariants: [
        "Hire skilled labor and trade workers for any job — a few hours or full-time. ChambaNow is built for you.",
        "From day labor to skilled trades, hire the workers who get real work done — fast, local, and bilingual.",
        "Built for hiring labor and trade workers — post a job free and connect with verified local pros today.",
      ],
      signupLaborer: "Join as a Worker",
      signupHirer: "Join as a Hirer",
      signupLaborerNote: "Free — get hired today",
      signupHirerNote: "Browse & message workers",
      stat1Value: "2min",
      stat1Label: "Avg. time to match",
      stat2Value: "Free",
      stat2Label: "To list your skills",
      stat3Value: "Local",
      stat3Label: "Workers near you",
      howItWorksLink: "How it works",
      getStarted: "Get Started",
      alreadyAccount: "Already have an account?",
      signIn: "Sign In",
    },
    how: {
      title: "HOW IT WORKS",
      laborer: {
        title: "FOR WORKERS",
        desc: "Free forever. Post your skills, availability and rate. Get hired same-day.",
        items: ["Create your profile in 2 minutes", "Add skills, ZIP code, hourly rate", "Toggle your live availability on", "Search and apply to thousands of job postings", "Get messaged by hirers directly in-app"],
      },
      hirer: {
        title: "FOR HIRERS",
        desc: "Browse verified workers. Filter by skill, ZIP, rate. Message in-app.",
        items: ["Sign up in 30 seconds", "Two ways to hire: instant pass or unlimited job postings", "Filter by skill, ZIP, rate, transport", "Message workers directly in-app", "Arrange pickup or transport yourself"],
      },
    },
    skills: { title: "POPULAR SKILLS", subtitle: "From construction to landscaping. If it’s manual work, it’s on ChambaNow." },
    finalCta: { title: "READY TO WORK?", subtitle: "Join hundreds of workers and hirers connecting on ChambaNow.", btn: "Get Started" },
    auth: {
      loginTitle: "SIGN IN", signupTitle: "CREATE ACCOUNT",
      email: "Email", password: "Password", name: "Full Name",
      role: "I am a...", roleLaborer: "Worker (looking for work)", roleHirer: "Hirer (looking to hire)",
      workerSafety: "ChambaNow respects your privacy and never sells or shares your data.",
      submitLogin: "SIGN IN", submitSignup: "CREATE ACCOUNT",
      forgotPassword: "Forgot password?",
      forgotTitle: "RESET PASSWORD",
      forgotIntro: "Enter your account email and we'll send you a link to reset your password.",
      forgotSubmit: "SEND RESET LINK",
      forgotSent: "If an account exists for that email, we've sent a password reset link. Check your inbox (and spam).",
      backToLogin: "Back to sign in",
      resetTitle: "CHOOSE A NEW PASSWORD",
      resetIntro: "Enter a new password for your account.",
      newPassword: "New password",
      confirmPassword: "Confirm new password",
      resetSubmit: "RESET PASSWORD",
      resetSuccess: "Password updated. You can now sign in.",
      resetMismatch: "Passwords don't match.",
      resetTooShort: "Password must be at least 8 characters.",
      resetInvalidLink: "This reset link is invalid or has expired. Please request a new one.",
      orGoogle: "or continue with Google", google: "Continue with Google",
      noAccount: "No account?", hasAccount: "Already have an account?",
      switchSignup: "Sign up", switchLogin: "Sign in",
      referralBannerValid: "🎁 You were invited by {name} — you'll get ${amount} off your first Plus subscription.",
      referralBannerInvalid: "That referral code isn't valid, but you can still sign up.",
      agreePrefix: "I have read and agree to the",
      agreeTerms: "Terms of Use",
      agreeAnd: "and",
      agreePrivacy: "Privacy Policy",
      agreeRequired: "You must agree to the Terms of Use and Privacy Policy to create an account.",
    },
    referral: {
      navLink: "Refer & Earn",
      pageTitle: "REFER FRIENDS, EARN $10 CASH",
      subtitle: "Share your link. When a friend subscribes to Hirer Plus, you get $10 and they get $5 off. Cash out via PayPal, Venmo or Zelle once you hit $20.",
      yourCodeLabel: "YOUR REFERRAL CODE",
      yourLinkLabel: "YOUR SHARE LINK",
      copyCode: "Copy code",
      copyLink: "Copy link",
      copied: "Copied!",
      shareTitle: "ChambaNow — find workers fast",
      shareText: "Join me on ChambaNow. Sign up with my link and get $5 off your first Hirer Plus subscription:",
      shareWhatsApp: "WhatsApp",
      shareSms: "SMS",
      shareEmail: "Email",
      balanceTitle: "YOUR EARNINGS",
      balanceTotal: "Total earned",
      balanceAvailable: "Available for payout",
      balancePaidOut: "Already paid out",
      successfulReferrals: "Successful referrals",
      pendingReferrals: "Pending (signed up, hasn't bought Plus)",
      payoutBtn: "REQUEST PAYOUT",
      payoutLockedBtn: "{remaining} more to unlock payout",
      payoutPendingBadge: "Payout pending",
      payoutModalTitle: "REQUEST PAYOUT",
      payoutMethodLabel: "Payout method",
      payoutPayPal: "PayPal",
      payoutVenmo: "Venmo",
      payoutZelle: "Zelle",
      payoutDestPayPal: "PayPal email",
      payoutDestVenmo: "Venmo handle or phone",
      payoutDestZelle: "Zelle email or phone",
      payoutConfirm: "REQUEST ${amount}",
      payoutCancel: "Cancel",
      payoutRequested: "Payout requested! Admin will send within 3-5 business days.",
      historyTitle: "REFERRAL HISTORY",
      historyEmpty: "No referrals yet. Share your link to earn $10 per friend!",
      historyHeaderFriend: "Friend",
      historyHeaderStatus: "Status",
      historyHeaderDate: "Date",
      historyHeaderAmount: "Amount",
      statusPending: "Signed up",
      statusCredited: "Earned",
      statusPaidOut: "Paid out",
      howItWorksTitle: "HOW IT WORKS",
      step1: "Share your link with friends, family, contractors — anyone who hires workers.",
      step2: "They sign up and subscribe to Hirer Plus ($29.99/mo). They save $5 off.",
      step3: "You earn $10. Cash out via PayPal, Venmo or Zelle once you hit $20.",
      step4: "No cap. No expiration. Keep earning forever.",
      materialsTitle: "MARKETING MATERIALS",
      materialsSubtitle: "Download ready-to-print flyers, tear-offs, and social posts with your QR code already baked in. Every scan sends people to your signup link.",
      materialsQRPreview: "YOUR PERSONAL QR CODE",
      materialsQRHint: "Every material below carries this same QR code — pointing to your unique referral link.",
      materialsDownloadPng: "Download PNG",
      materialsShare: "Share",
      materialsShareFallback: "Image saved to your device — attach it to your post.",
      materialsView: "View full-size",
      material1Label: "Instagram Story",
      material1Use: "Post to Instagram, TikTok, Facebook Stories, or WhatsApp Status.",
      material2Label: "Square Social Post",
      material2Use: "Perfect for the Instagram feed, LinkedIn, or Facebook.",
      material3Label: "Tear-Off Flyer (8 tabs)",
      material3Use: "Print on 8.5×11 paper. Pin to bulletin boards — each tear-off tab has its own QR.",
      material4Label: "Vertical Flyer",
      material4Use: "Print for coffee shops, hardware stores, community centers, laundromats.",
      material5Label: "Wide Banner",
      material5Use: "Use as a header on group chats, email signatures, or a Facebook cover photo.",
      spreadTitle: "HOW TO SPREAD THE WORD",
      spreadTip1Title: "Print & post locally",
      spreadTip1Body: "Ask hardware stores, coffee shops, laundromats, and community centers if you can put a flyer on their bulletin board. The tear-off template is designed for this.",
      spreadTip2Title: "Post on social",
      spreadTip2Body: "Drop the square post on Facebook groups for contractors, homeowners, or immigrants in your city. Use the vertical story on Instagram/TikTok.",
      spreadTip3Title: "Text your contacts",
      spreadTip3Body: "Send the banner + your link in group chats with fellow tradespeople, neighbors, and family. One share can turn into $10.",
      spreadTip4Title: "Talk it up in person",
      spreadTip4Body: "Hand a flyer to hirers at the parking lot, home depot, or job site. Anyone who scans and signs up gets $5 off — and you get $10.",
    },
    laborerForm: {
      title: "YOUR WORKER PROFILE",
      subtitle: "Fill this out once. Stay visible to hirers in your area.",
      liveTitle: "LIVE GIG MODE",
      liveSubtitle: "Get hired instantly — show up in 'Hire Now' searches and chat with hirers in real time. For same-day work.",
      jobBoardTitle: "JOB BOARD",
      jobBoardSubtitle: "Browse posted jobs (day labor, contract, temp, permanent, per-diem). Apply with your profile — the hirer reviews your application before chatting.",
      jobBoardBrowse: "BROWSE JOBS",
      jobBoardApplications: "MY APPLICATIONS",
      liveOn: "I'M AVAILABLE NOW",
      liveOff: "OFF — I'M NOT AVAILABLE",
      liveHintOn: "You'll show up in 'Hire Now' searches. Tap again to go offline.",
      liveHintOff: "Hirers can't see you in 'Hire Now' results until you toggle this on.",
      liveProfileFirst: "Save your profile below first, then you can toggle live availability.",
      liveExpiresIn: "Auto-off in",
      liveAutoOff: "(auto-turns off after 8h)",
      phone: "Phone Number", skills: "Skills (select all that apply)",
      rateMin: "Min Hourly Rate ($)", rateMax: "Max Hourly Rate ($)",
      zip: "ZIP Code", city: "City",
      transport: "I have my own transportation",
      available: "I am available for work",
      jobAlerts: "Email me new jobs near me",
      jobAlertsHint: "Get an email when a new job matching your skills is posted within 50 miles.",
      dates: "Future Available Dates",
      datesHint: "Tap the dates you'll be free. Pick a time-of-day window for each.",
      presetsLabel: "Quick add",
      presetNext7: "Next 7 days",
      presetWeekdays: "Weekdays",
      presetWeekends: "Weekends",
      presetClear: "Clear all",
      dashBrowseCta: "Browse jobs near you",
      dashBrowseSub: "See paid jobs posted near you and apply in one tap.",
      timeMorning: "Morning",
      timeAfternoon: "Afternoon",
      timeEvening: "Evening",
      timeSlotsLabel: "Times",
      noDatesPicked: "No dates picked yet — tap a date on the calendar above.",
      bio: "Short Bio (optional)", bioNoContact: "No phone numbers, emails or links — hirers message you through ChambaNow.", years: "Years of Experience",
      resumeTitle: "RESUME / CERTIFICATIONS",
      resumeSubtitle: "Upload one document so hirers can quickly see your background.",
      resumeNoContact: "Important: Do NOT include your phone number or email. Include only experience, work history, education, and certifications / licenses.",
      resumeHint: "PDF only · Max 5 MB",
      portfolioTitle: "WORK PORTFOLIO",
      portfolioSubtitle: "Show off photos of your work — paying hirers see these on your profile.",
      portfolioReviewNote: "Photos are reviewed by our team before hirers can see them.",
      portfolioAdd: "Add photos",
      portfolioUploading: "Uploading…",
      portfolioPending: "Pending review",
      portfolioApproved: "Approved",
      portfolioMax: "You can upload up to {n} photos.",
      portfolioBadType: "Please choose an image (JPG or PNG).",
      portfolioTooBig: "Image too large (max 5 MB).",
      portfolioRemoveConfirm: "Remove this photo?",
      portfolioRemoved: "Photo removed",
      portfolioUploaded: "Photo uploaded — pending review",
      portfolioEmpty: "No photos yet. Add a few to stand out.",
      portfolioCover: "Cover",
      portfolioReorderHint: "Drag photos to reorder — your first photo leads your profile.",
      portfolioRejectedTitle: "Needs attention",
      portfolioRejected: "Rejected",
      portfolioRejectedToast: "A portfolio photo was rejected",
      portfolioCaptionPlaceholder: "Add a caption (optional)",
      resumeCurrent: "Current resume",
      resumeUpload: "UPLOAD RESUME",
      resumeReplace: "REPLACE",
      resumeRemove: "REMOVE",
      resumeUploading: "Uploading…",
      resumeUploaded: "Resume uploaded — pending review.",
      resumeStatusPending: "Pending review",
      resumeStatusApproved: "Approved",
      resumeStatusRejected: "Not approved",
      resumePendingNote: "Your resume is awaiting review — hirers can't see it until it's approved.",
      resumeRejectedNote: "Your resume wasn't approved. Please replace it with a new one.",
      resumeRemoved: "Resume removed.",
      resumeRemoveConfirm: "Remove your resume?",
      resumeTooBig: "File too large. Max 5 MB.",
      resumeBadType: "Resumes must be a PDF. Please re-save as a PDF and try again.",
      save: "SAVE PROFILE", saved: "Profile saved!",
      welcomeTitle: "WELCOME — BUILD YOUR PROFILE",
      welcomeBody: "Fill out the form below so hirers can find you. It takes about 2 minutes. You're free to skip live availability for now — turn it on whenever you're ready to get hired.",
      welcomeSteps: ["Add your phone, skills and ZIP code", "Set your hourly rate range", "Save your profile", "Tap 'GO LIVE' when you're ready to work"],
    },
    search: {
      title: "FIND WORKERS",
      distance: "Distance",
      distanceAny: "Any distance",
      dist10: "Within 10 miles",
      dist25: "Within 25 miles",
      dist50: "Within 50 miles",
      dist100: "Within 100 miles",
      dashPostJob: "Post a Job",
      dashPostJobDesc: "Reach local workers now",
      dashReview: "Review Applicants",
      dashReviewDesc: "See who applied to your jobs",
      dashFind: "Find Workers",
      dashFindDesc: "Search & message available workers",
      jobsPagePromoTag: "HIRER PLUS",
      jobsPagePromoTitle: "Build your company Jobs page",
      jobsPagePromoDesc: "A branded, shareable page with your logo, colors, and all your open jobs — set it up in 3 quick steps.",
      jobsPagePromoCta: "Set it up",
      jobsPagePromoLearn: "Learn more",
      filters: "FILTERS",
      modeNow: "HIRE NOW",
      modeLater: "HIRE LATER",
      modeNowHint: "Only workers available right now",
      modeLaterHint: "Pick a future date",
      availableTitle: "Search available workers",
      availableHint: "Workers available right now near you",
      pickDate: "Pick a date",
      skill: "Skill", any: "Any",
      zip: "ZIP Code", date: "Date",
      location: "City, State or ZIP", locationPlaceholder: "City, State or ZIP",
      viewList: "List", viewMap: "Map", mapLoading: "Loading workers, please wait…", viewProfile: "View profile", viewPortfolio: "View portfolio",
      rateMin: "Min Rate", rateMax: "Max Rate", messageCta: "Message",
      transport: "Has Own Transport",
      timeOfDay: "Time of Day",
      timeMorning: "Morning",
      timeAfternoon: "Afternoon",
      timeEvening: "Evening",
      anyTime: "Any time",
      verifiedOnly: "Verified workers only",
      includeOffline: "Include offline workers",
      verifiedBadge: "VERIFIED",
      photosBadge: "PHOTOS",
      apply: "APPLY FILTERS", reset: "RESET",
      results: "RESULTS", noResults: "No workers match your filters yet.",
      locked: "Get Hirer Access to message workers",
      unlockBtn: "HIRE THIS WORKER",
      contact: "Contact", phone: "Phone", email: "Email",
      contactBtn: "MESSAGE",
      privateNote: "Phone & email stay private — all contact is in-app.",
      yearsExp: "yrs exp", rate: "Rate", transport2: "Transport",
      ownTransport: "Own", needsPickup: "Needs pickup",
      liveDot: "AVAILABLE NOW",
      milesAway: "mi away",
      viewResume: "VIEW RESUME",
    },
    pass: {
      active: "HIRING PASS ACTIVE",
      planLabel: "HIRER PLUS",
      subActiveBody: "Subscription Active",
      getPassBody: "Get a 48-Hour Job Pass",
      dayUnit: "day",
      daysUnit: "days",
      expires: "Expires in",
      inactive: "NO ACTIVE PASS",
      buyTitle: "GET 48-HOUR JOB PASS",
      buyDesc: "48 hours of hiring access for one job — search, message & review applicants. Extend anytime before it ends.",
      buyBtn: "GET HIRER ACCESS",
      postFreeLabel: "GET STARTED",
      postFreeTitle: "POST UNLIMITED JOBS — FREE FOR 30 DAYS",
      postFreeDesc: "Your first month of Hirer Plus is on us — it starts the day you sign up. Post unlimited jobs, no card required.",
      postFreeBtn: "Post a job free",
      postJobBtn: "Post a job",
      plansTitle: "Ready to hire?",
      plansDesc: "See 48-Hour Job Pass and Hirer Plus options to view applicants and message workers.",
      plansBtn: "See plans & pricing",
      processing: "Processing payment...",
    },
    success: { title: "PAYMENT SUCCESSFUL", subtitle: "Your 48-Hour Job Pass is active. Start hiring now.", goSearch: "START SEARCHING" },
    chat: {
      inboxTitle: "INBOX",
      emptyInbox: "No conversations yet.",
      startNew: "Find workers to start a chat.",
      placeholder: "Type your message…",
      send: "SEND",
      backToInbox: "BACK",
      viewProfile: "View worker profile",
      screeningTitle: "Application answers",
      noAnswer: "No answer provided",
      thread: "CONVERSATION",
      unread: "new",
      youNeedPass: "You need active hiring access (48-Hour Job Pass or Hirer Plus) to send messages.",
      passExpired: "Hiring access ended — extend your 48-Hour Job Pass or reactivate Hirer Plus to keep chatting.",
      privacyNote: "Your phone & email are never shared. The other side gets a notification when you send a message.",
      enablePush: "Get notified instantly when someone messages you",
      enablePushBtn: "ENABLE NOTIFICATIONS",
      pushEnabled: "Notifications enabled",
      pushDenied: "Notifications blocked in browser settings",
      makeOffer: "MAKE AN OFFER",
      offerTitle: "SEND AN OFFER",
      offerRateType: "Rate Type",
      offerHourly: "Hourly Rate",
      offerJob: "Total Job Rate",
      offerRate: "Amount ($)",
      offerLocation: "Job Location",
      offerDuration: "Estimated Duration (hours)",
      offerTransport: "I will provide transport for the worker",
      offerNotes: "Notes (optional)",
      offerSubmit: "SEND OFFER",
      offerSent: "Offer sent",
      offerAccept: "ACCEPT",
      offerReject: "REJECT",
      offerAccepted: "OFFER ACCEPTED",
      offerRejected: "OFFER REJECTED",
      offerPending: "OFFER PENDING",
      offerBadge: "OFFER",
      offerStatusLabel: "Status",
      reLabel: "Re:",
      viewJob: "View job",
      lockedTitle: "Conversations locked",
      lockedDesc: "Your 48-Hour Job Pass or Hirer Plus has ended. Reactivate to view and continue your conversations — nothing is deleted.",
      reactivate: "SEE PLANS",
      jobConfirmed: "JOB CONFIRMED",
      jobConfirmedDesc: "Offer accepted. Coordinate the arrival time and final details in the chat below.",
      markComplete: "MARK JOB COMPLETE",
      markCompleteConfirm: "Mark this job as complete? You'll both be able to leave a review.",
      jobCompleted: "JOB COMPLETED",
      leaveReview: "LEAVE A REVIEW",
      rateTitle: "RATE YOUR EXPERIENCE",
      rateWorker: "How was this worker?",
      rateHirer: "How was working with this hirer?",
      reviewCommentPlaceholder: "Add a comment (optional)…",
      reviewSubmit: "SUBMIT REVIEW",
      reviewSubmitted: "Review submitted — thank you!",
      youRated: "You rated",
      completeFailed: "Could not mark complete",
      reviewFailed: "Could not submit review",
    },
    reviews: {
      newTag: "New",
      reviewsLabel: "reviews",
      reviewsTitle: "Reviews",
      ratingHiddenNote: "Ratings appear after 5+ reviews",
    },
    footer: { tagline: "The virtual worker marketplace.", rights: "All rights reserved.", contact: "Contact", press: "Press & Media", hiringIn: "HIRING NOW IN", hireIn: "HIRE WORKERS IN", moreCities: "All cities", terms: "Terms of Use", privacy: "Privacy Policy" },
    landing: {
      birthdayRibbonBold: "Happy 250th Birthday, America.",
      birthdayRibbon: "Read our letter to the workers, immigrants, and dreamers who built the country.",
      birthdayRibbonCta: "Read the letter",
      value: {
        eyebrow: "ONE PLATFORM. BOTH SIDES.",
        title: "Everything you get",
        subtitle: "Built for the people who do the work — and the people who need it done. No middlemen, no agency fees.",
        workersTag: "FOR WORKERS",
        workersTitle: "Get hired, get paid",
        workersFree: "100% FREE — FOREVER",
        workers: [
          "Post your availability and get found by nearby hirers",
          "Your own shareable profile link to land more work",
          "Real-time chat translation — talk to any hirer in your language",
          "Apply to unlimited jobs, short-term and long-term",
          "Set your own rates and skills — no commissions taken",
        ],
        workersCta: "Join free as a worker",
        hirersTag: "FOR HIRERS",
        hirersTitle: "Hire in minutes",
        hirersFree: "FIRST MONTH FREE",
        hirers: [
          "Post unlimited jobs free for 30 days — no card required",
          "Your own company Jobs page to share & embed on your site",
          "Reach available workers by skill, city and radius",
          "Message & manage every applicant in one place",
          "Real-time translation built into every conversation",
        ],
        hirersCta: "Start hiring",
      },
    },
    translation: {
      eyebrow: "LIVE TRANSLATION — INCLUDED FREE",
      title: "TYPE IN YOUR LANGUAGE.",
      titleAccent: "THEY READ IN THEIRS.",
      subtitle: "Chat naturally with any worker or hirer on ChambaNow. Messages auto-translate the moment they're sent — no copying, no pasting, no awkward miscommunication.",
      bullets: [
        "English ↔ Spanish (more languages coming)",
        "Original + translation shown side-by-side",
        "Works for job negotiations, safety instructions, directions",
        "Zero setup — it just works",
      ],
      cta: "Try live translation free",
      mockLive: "LIVE CHAT",
      mockJobId: "JOB #4821",
      workerName: "José R.",
      workerTranslated: "Yes, I have my own tools and transport. I can be there in 30 minutes. What time do we start?",
      hirerName: "Mike H.",
      hirerTranslated: "Perfecto — llegaré a la dirección en 30 minutos también. Trae gafas de seguridad. Tarifa: $28/hr, en efectivo al final del día.",
      mockComposer: "Message translated as you type…",
      mockFooter: "AUTO-TRANSLATED IN REAL TIME · POWERED BY CHAMBANOW",
    },
    referAndEarn: {
      eyebrow: "CHAMBANOW · REFER & EARN",
      h1Line1: "SHARE CHAMBANOW.",
      h1Line2: "EARN $10 CASH.",
      subtitle: "Invite friends, contractors, and neighbors. When they subscribe to Hirer Plus, you get $10 — and they get $5 off. Cash out via PayPal, Venmo or Zelle once you hit $20.",
      ctaLoggedOut: "Sign up & get your link",
      ctaLoggedIn: "Get your referral link",
      ctaSignin: "I already have an account",
      freeToJoin: "Free to join. No cap on referrals. Cash out any time above $20.",
      stat1Value: "$10", stat1Label: "PER REFERRAL",
      stat2Value: "$5", stat2Label: "OFF FOR YOUR FRIEND",
      stat3Value: "$20", stat3Label: "MIN. PAYOUT",
      howTitle: "HOW IT WORKS",
      howSubtitle: "Three steps, cash in your account.",
      step1: { title: "GRAB YOUR LINK", body: "Sign in, open your Refer & Earn dashboard, and copy your unique referral link." },
      step2: { title: "SHARE IT ANYWHERE", body: "Text, email, WhatsApp, Instagram, TikTok, on a jobsite, at church — wherever your people are." },
      step3: { title: "GET PAID", body: "Every friend who subscribes to Hirer Plus adds $10 to your balance. Cash out via PayPal, Venmo or Zelle at $20+." },
      rewardsTitle: "WHAT EVERYONE GETS",
      rewardYouLabel: "YOU EARN",
      rewardYouBody: "For every friend who becomes a paying Hirer Plus subscriber using your link.",
      rewardYouBullets: [
        "Credited instantly when they subscribe",
        "Stackable — no cap, refer as many as you want",
        "Cash out via PayPal, Venmo or Zelle at $20+",
      ],
      rewardFriendLabel: "YOUR FRIEND GETS",
      rewardFriendBody: "$5 off their first Hirer Plus month when they use your link.",
      rewardFriendBullets: [
        "Automatic — no coupon code to enter",
        "Applied at checkout on first subscription",
        "Doesn't cost them anything to accept",
      ],
      faqTitle: "QUESTIONS",
      faqs: [
        { q: "Who can refer?", a: "Anyone with a ChambaNow account — worker or hirer. You don't have to be a paying subscriber yourself." },
        { q: "How do I get paid?", a: "Once your balance hits $20, request a payout from your Refer & Earn dashboard. We send via PayPal, Venmo or Zelle." },
        { q: "When do I get credited?", a: "The moment your friend's first Hirer Plus payment goes through. Credits show up in your dashboard immediately." },
        { q: "Is there a limit?", a: "No cap. Refer 5 people, 50, or 500 — every one earns you $10." },
        { q: "What if my friend cancels?", a: "You keep any credits already earned. Future months from that person won't add more." },
        { q: "Can I refer myself?", a: "No — the friend must be a different person with a different email and payment method. Duplicate accounts are removed." },
      ],
      finalCtaTitle: "READY TO EARN?",
      finalCtaBody: "It's free to join, takes 60 seconds, and there's no cap on how much you can make.",
    },
    press: {
      pageTitle: "PRESS & MEDIA",
      pageSubtitle: "Releases, brand assets, and media resources for journalists and partners covering ChambaNow.",
      mediaInquiries: "Media inquiries:",
      mailingAddress: "MAILING ADDRESS:",
      releasesTitle: "PRESS RELEASES",
      noReleases: "No press releases yet — check back soon.",
      readMore: "Read release",
      backToPress: "Back to Press",
      notFound: "Release not found.",
      kitTitle: "BRAND KIT",
      kitIntro: "All assets are licensed for editorial use covering ChambaNow. Logos and the brand banner are below; please don't alter the orange, the wordmark, or the lightning mark.",
      logos: "LOGOS",
      colors: "COLORS",
      typography: "TYPOGRAPHY",
      voice: "BRAND VOICE",
      downloads: "DOWNLOADS",
      copied: "copied",
      teamTitle: "FOUNDER & TEAM",
      teamIntro: "Approved headshots and bios for editorial use.",
      founderName: "Barry Graham",
      founderRole: "Founder & CEO, ChambaNow",
      founderBio: "Barry Graham founded ChambaNow to bring the home-improvement-store parking lot online — a faster, safer way for workers and hirers in Champaign-Urbana to find each other. He focuses on dignity-first product design and bilingual access for the workers who keep neighborhoods running.",
      founderQuote: "\"Every worker waiting in a parking lot is a missed opportunity for a family that needed the help an hour ago. ChambaNow closes that gap.\"",
      downloadPhoto: "Download photo",
    },
    jobs: {
      title: "JOBS",
      subtitle: "Day labor, contract, temp-to-hire, permanent and per-diem openings.",
      industry: "Industry",
      employmentType: "Employment Type",
      zip: "ZIP Code",
      location: "City, State or ZIP", locationPlaceholder: "City, State or ZIP",
      viewList: "List", viewMap: "Map", viewJob: "View job",
      temporary: "Temporary?",
      any: "Any", yes: "Yes", no: "No",
      loading: "Loading…",
      noResults: "No active jobs match your filters.",
      transport: "Transport",
      self: "Self",
      temp: "TEMP",
      perHr: "hr", perYr: "yr", perJob: "job",
      // employment-type labels
      day_labor: "Day Labor", short_term: "Short Term", contract: "Contract",
      temp_to_hire: "Temp-to-Hire", permanent: "Permanent", full_time: "Full-time",
      part_time: "Part-time", per_diem: "Per Diem",
      sortBy: "SORT",
      sortDistance: "Distance",
      sortRecent: "Most Recent",
      sortingFrom: "Sorted by distance from ZIP",
      enterZipForDistance: "Enter a ZIP in the filter panel to sort by distance.",
      zipPlaceholder: "e.g. 61820",
      search: "Search",
      searchPlaceholder: "e.g. welder, warehouse, driver",
      zipHelp: "Used as the starting point for distance & radius.",
      radius: "Search radius",
      radiusAny: "Any distance",
      radiusWithin: "Within {n} mi",
      radiusNote: "Showing ChambaNow jobs within {n} mi of {zip}, then partner jobs nearby.",
      applyFilters: "Apply filters",
      applyFiltersAgain: "Refresh results",
      clearFilters: "Clear filters",
      milesAway: "mi away",
      partnerBadge: "ChambaNOW Partner",
      externalApply: "View on partner site",
      partnerSectionTitle: "More jobs from our partners",
      partnerHint: "External listings — you'll apply on the partner's site.",
      partnerSectionLoading: "Finding more jobs from our partners near you — this can take a few seconds…",
      partnerNone: "No partner jobs found nearby right now. Try a wider radius or a different area.",
      partnerApply: "Apply on partner site",
      partnerAbout: "About this role",
      partnerNote: "This is an external listing from our partner network. Clicking apply takes you to the original posting to finish applying.",
      partnerVia: "Listed via",
      partnerBack: "Back to jobs",
      partnerExpired: "This partner listing is no longer available.",
      partnerBrowseAll: "Browse all jobs",
      partnerNotFound: "This partner listing is no longer available.",
      partnerLoading: "Loading listing…",
      partnerListApply: "Apply",
      partnerSignIn: "Sign in to apply",
      partnerResponsibilities: "What you'll do",
      partnerSkills: "Helpful skills",
      partnerPay: "Pay & compensation",
      partnerLocationHeading: "Working in this area",
      partnerHowToApply: "How to apply on ChambaNow",
      partnerFaq: "Frequently asked questions",
      partnerRelated: "Similar partner jobs",
      partnerShare: "Share",
      partnerCopied: "Link copied!",
      partnerShareThis: "Share this job",
    },
    cityJobs: {
      browseByCity: "BROWSE BY CITY",
      eyebrow: "CHAMBANOW · CITY",
      heroPrefix: "Day Labor & Skilled Trades Jobs in",
      postJobCta: "Post a job (Hirer Plus)",
      findWorkersCta: "Find workers",
      browseJobsCta: "Browse open jobs",
      workerSignupCta: "Sign up to get hired",
      hiringLink: "Are you hiring? Post a job free",
      openJobs: "Open Jobs",
      activeJob: "active job",
      activeJobs: "active jobs",
      empty: "No active jobs in {city} right now. Be the first to post — workers in this city see new postings instantly.",
      nearbyTitle: "OTHER CITIES HIRING",
      loadMore: "Load more",
      nearbySubtitle: "Jump to another city with active day-labor postings on ChambaNow.",
      allJobs: "All jobs",
      jobsInPrefix: "Jobs in",
      browseAllJobs: "Browse all jobs",
      notFoundTitle: "CITY NOT YET ON CHAMBANOW",
      notFoundBody: "No active job postings have been made in this city yet. City pages appear automatically as soon as a hirer posts a job there.",
    },
    cityDir: {
      eyebrow: "CITY DIRECTORY",
      title: "Day Labor & Skilled Trades Work in Every City",
      subtitle: "Browse the biggest 1,000 U.S. cities. Find day-labor jobs or hire available workers near you — post unlimited jobs free for 30 days, no card required.",
      loading: "Loading cities…",
      jobsLink: "Jobs",
      hireLink: "Hire",
      searchPlaceholder: "Search a city or state…",
      noResults: "No cities match your search.",
      cityCount: "cities",
    },
    hireCity: {
      eyebrow: "HIRE WORKERS",
      heroPrefix: "Hire Day Labor & Skilled Trades Workers in",
      heroSuffix: "Available Today",
      subtitle: "Post your job free and connect with available day labor and skilled trades workers in {city}. No agency fees — negotiate rates directly.",
      postFree: "Post a Job — Free",
      postFreeNote: "Post unlimited jobs free for 30 days. No card required.",
      availableNow: "{count} available now",
      workersReady: "workers ready to work in {city}",
      noWorkers: "Be the first to hire here",
      noWorkersBody: "Post your job free and we'll notify workers in {city} the moment it goes live.",
      topSkills: "In-demand skills",
      availableWorkers: "Available Workers",
      anonNote: "Worker identities are protected. Sign up free to view profiles and contact workers.",
      yrsExp: "yrs",
      ownTransport: "Transport",
      perHr: "/hr",
      signupToContact: "Sign up to contact",
      browseJobs: "Browse jobs in {city}",
      howTitle: "How hiring works",
      step1: "Post your job free in 60 seconds",
      step2: "Available workers apply directly",
      step3: "Message and hire workers — your free month starts the day you sign up",
      ctaBottom: "Ready to hire in {city}?",
      loading: "Loading…",
    },
    shareProfile: {
      title: "SHARE YOUR PROFILE",
      subtitle: "Post this link anywhere — WhatsApp, Facebook groups, friends. Anyone who opens it can hire you on ChambaNow.",
      copy: "Copy",
      copied: "Copied!",
      copyFailed: "Could not copy",
      share: "Share",
      preview: "Preview",
      shareTitle: "Hire me on ChambaNow",
      shareText: "Check out my ChambaNow profile and hire me:",
    },
    workerProfile: {
      loading: "Loading…",
      portfolioTitle: "Work Portfolio",
      portfolioLocked: "This worker has {n} portfolio photo(s). Active hiring access (48-Hour Job Pass or Hirer Plus) is required to view them.",
      portfolioUnlockCta: "See plans & pricing",
      reportPrompt: "Why are you reporting this photo? (optional)",
      reportThanks: "Thanks — our team will review this photo.",
      metaTitleSuffix: "Available for hire on ChambaNow",
      metaDesc: "Hire {name} on ChambaNow — view skills, availability and hire directly.",
      notFoundTitle: "WORKER NOT FOUND",
      notFoundBody: "This profile link is no longer active. Browse available workers and jobs instead.",
      availableNow: "Available now",
      skills: "Skills",
      yrsExp: "yrs exp",
      ownTransport: "Has transport",
      perHr: "/hr",
      ctaTitle: "Hire {name} today",
      ctaBody: "Contact details and messaging are protected. Create a free hirer account to message {name} and get to work.",
      hireCta: "Sign up to hire {name}",
      messageCta: "Message {name}",
      messageTitle: "Message {name}",
      messageBody: "Start a conversation with {name} right here on ChambaNow — no phone numbers or emails needed.",
      ctaNote: "Free to sign up. Post unlimited jobs free for 30 days — no card required.",
      shareThisProfile: "Share this profile",
      shareMessage: "Check out {name} on ChambaNow — available to hire now!",
    },
    companyJobs: {
      eyebrow: "COMPANY JOBS",
      openings: "Open Positions",
      jobSingular: "open position",
      jobPlural: "open positions",
      emptyBody: "{company} isn't hiring right now. Check back soon.",
      visitWebsite: "Visit website",
      viewJob: "View job",
      poweredBy: "Jobs powered by ChambaNow",
      notFoundTitle: "COMPANY NOT FOUND",
      notFoundBody: "This company page isn't available. Browse all jobs instead.",
      loading: "Loading…",
    },
    shareCompany: {
      title: "SHARE YOUR JOBS PAGE",
      subtitle: "One link with all your open jobs — post it on your website, share on social media, or send to candidates.",
      needsName: "Add a company name below and save to activate your public Jobs page.",
      copy: "Copy",
      copied: "Copied!",
      copyFailed: "Could not copy",
      share: "Share",
      preview: "Preview",
      shareTitle: "Jobs at our company on ChambaNow",
      shareText: "See our open jobs and apply:",
      sectionTitle: "COMPANY PROFILE",
      companyName: "Company name",
      companyNamePlaceholder: "e.g. Acme Landscaping",
      companyAbout: "About your company",
      companyAboutPlaceholder: "Tell candidates about your company (optional)",
      companyWebsite: "Website",
      companyWebsitePlaceholder: "https://yourcompany.com",
      wizardCta: "Design your Jobs page with the setup wizard",
      wizardGo: "Open wizard",
    },
    companySetup: {
      eyebrow: "SETUP WIZARD",
      title: "Build your company Jobs page",
      subtitle: "A branded jobs page companies pay thousands for — yours in 3 quick steps.",
      step1Short: "Basics",
      step2Short: "Branding",
      step3Short: "Launch",
      step1Title: "Company basics",
      step1Desc: "Tell candidates who you are. This becomes your public page's title and link.",
      step2Title: "Make it yours",
      step2Desc: "Add your logo and brand colors. Watch the live preview update as you go.",
      step3Title: "Launch & share",
      step3Desc: "Your page is live! Share this link anywhere to start receiving applicants.",
      companyName: "Company name",
      companyNamePlaceholder: "e.g. Acme Landscaping",
      companyAbout: "About your company",
      companyAboutPlaceholder: "A short intro candidates will see (optional)",
      companyWebsite: "Website",
      companyWebsitePlaceholder: "https://yourcompany.com",
      logo: "Company logo",
      uploadLogo: "Upload logo",
      remove: "Remove",
      bgColor: "Background",
      textColor: "Text",
      accentColor: "Accent",
      resetColors: "Reset to defaults",
      whereToShare: "WHERE TO SHARE IT",
      shareTips: [
        "Add it to your website under a \u201CJobs\u201D or \u201CWe're Hiring\u201D link",
        "Post it on your Facebook, Instagram, and LinkedIn pages",
        "Drop it in local community & neighborhood groups",
        "Put it on flyers, business cards, and job-site signage (as a QR code)",
        "Text or email it directly to candidates",
      ],
      copy: "Copy",
      copied: "Copied!",
      copyFailed: "Could not copy",
      share: "Share",
      shareText: "Check out our open jobs:",
      viewPage: "View page",
      back: "Back",
      next: "Next",
      saving: "Saving…",
      finish: "Done",
      nameRequired: "Please enter your company name",
      saveError: "Could not save. Please try again.",
      logoTooLarge: "That image is too large. Try one under 8MB.",
      logoError: "Could not read that image.",
      livePreview: "LIVE PREVIEW",
      previewEyebrow: "COMPANY JOBS",
      previewCompany: "Your Company",
      previewOpenings: "Open Positions",
      previewJob: "Position",
      previewType: "Day Labor",
      previewLocation: "Austin, TX",
      previewPowered: "Powered by ChambaNow",
    },
    industries: {
      construction: "Construction", landscaping: "Landscaping", moving: "Moving",
      cleaning: "Cleaning", painting: "Painting", plumbing: "Plumbing",
      electrical: "Electrical", roofing: "Roofing", warehouse: "Warehouse",
      restaurant: "Restaurant / Food", retail: "Retail", office: "Office",
      delivery: "Delivery", healthcare: "Healthcare", hospitality: "Hospitality",
      automotive: "Automotive", other: "Other",
      mechanical: "Mechanical",
    },
    postJob: {
      hirerPlusBadge: "HIRER PLUS",
      title: "POST A JOB",
      editTitle: "EDIT JOB",
      editSubtitle: "Update your posting. Changes are visible to workers immediately.",
      saveBtn: "SAVE CHANGES",
      saving: "Saving…",
      saved: "Job saved",
      subtitle: "Workers will see this in the Jobs feed. Required application fields will appear on the worker's apply form.",
      plusRequired: "Hirer Plus subscription required",
      plusRequiredTitle: "PLUS REQUIRED",
      plusRequiredDesc: "Posting jobs is a Hirer Plus feature. Subscribe for $29.99/month.",
      seePricing: "SEE PRICING",
      freeFirstBadge: "FREE FOR 30 DAYS",
      freeFirstNote: "Post unlimited jobs free for 30 days — no card required.",
      usedFreePostTitle: "FREE MONTH ENDED",
      usedFreePostDesc: "Your free month has ended. Subscribe to Hirer Plus to keep posting jobs and unlock applicant contact.",
      loading: "Loading…",
      jobTitle: "Job Title",
      jobTitlePlaceholder: "e.g. Backyard cleanup crew (2 days)",
      description: "Description",
      descriptionPlaceholder: "What does the worker need to do? Hours? Equipment?",
      markTemporary: "Mark as temporary work",
      rateType: "Rate Type",
      rateHourly: "Hourly", rateJob: "Total Job", rateSalary: "Annual Salary",
      rateAmount: "Rate ($)",
      duration: "Duration (hours)",
      city: "City",
      provideTransport: "I will provide transport",
      customQuestions: "Custom Application Questions (optional)",
      questionPlaceholder: "e.g. Do you have your own tools?",
      remove: "REMOVE", add: "Add",
      posting: "Posting...", post: "POST JOB",
      posted: "Job posted",
      failed: "Failed to post",
    },
    myJobs: {
      title: "JOBS DASHBOARD",
      postBtn: "POST A JOB",
      loading: "Loading…",
      noJobs: "No jobs posted yet.",
      applies: "APPLIES",
      statusActive: "ACTIVE",
      statusPaused: "PAUSED",
      statusEnded: "ENDED",
      viewApps: "View Applications",
      edit: "Edit",
      pause: "Pause",
      resume: "Resume",
      endTitle: "WHY ARE YOU ENDING THIS JOB?",
      endHelper: "This helps us improve ChambaNow. (Two-second click — no typing required.)",
      endReasonHired: "Hired someone through ChambaNow",
      endReasonExternal: "Hired someone outside the app",
      endReasonTooFew: "Not enough applicants",
      endReasonOther: "Other reason",
      endNotePlaceholder: "Anything you'd like us to know? (optional)",
      endConfirmBtn: "END JOB",
      endCancelBtn: "Cancel",
      end: "End Job",
      duplicate: "Duplicate",
      duplicated: "Job duplicated — edit the new copy",
      ended: "Job ended",
      paused: "Job paused",
      resumed: "Job resumed",
      confirmEnd: "End this job permanently? You can still duplicate it later, but it can't be reactivated.",
      ofExpiry: "Expires",
      duplicatedFrom: "Duplicated from another job",
    },
    apply: {
      back: "Back",
      title: "Applications",
      loading: "Loading…",
      noApps: "No applications yet.",
      ownTransport: "Own transport",
      needsTransport: "Needs transport",
      yrsExp: "yrs exp",
      resume: "Resume",
      reply: "REPLY",
      statusSubmitted: "submitted",
      statusReviewed: "reviewed",
      statusHired: "hired",
      statusRejected: "rejected",
      lockedBadge: "LOCKED",
      lockedTitle: "You've got applicants!",
      lockedBody: "Subscribe to Hirer Plus to unlock names, contact info, resumes, and messaging.",
      lockedCta: "Unlock with Hirer Plus",
    },
    threadExtra: {
      waitingHirer: "⏳ Waiting for hirer to view your application and reply",
      transportProvided: "Transport provided",
      transportSelf: "Worker arranges transport",
      sendFailed: "Send failed",
      offerFailed: "Could not send offer",
      respondFailed: "Could not respond",
      couldNotLoad: "Could not load",
      noMessages: "No messages yet — say hi!",
      remindWorker: "Send reminder",
      reminderSent: "Reminder emailed to the worker.",
      reminderRateLimited: "Already reminded in the last 24 hours.",
      reminderFailed: "Could not send reminder",
    },
    jobDetail: {
      back: "Back",
      loading: "Loading…",
      notFoundTitle: "Job no longer available",
      notFoundBody: "This job posting has expired or been removed.",
      loadErrorTitle: "Couldn't load this job",
      loadErrorBody: "Something went wrong. Please try again.",
      retry: "Retry",
      browseAll: "Browse all jobs",
      moreInCity: "More jobs in",
      relatedTitle: "Related jobs",
      seeAllIn: "See all jobs in",
      share: "Share",
      shareCopied: "Link copied!",
      shareThisJob: "Share this job",
      temporary: "TEMPORARY",
      transportProvided: "Transport provided",
      selfTransport: "Self transport",
      perHr: "hr", perYr: "yr", perJob: "job",
      applyNow: "APPLY NOW",
      signInToApply: "SIGN IN TO APPLY",
      hirerViewing: "You're viewing this as a hirer — switch to a worker account to apply.",
      testJob: "TEST JOB",
      testJobBadge: "TEST JOB",
      testJobSignIn: "Sign in to see current live job postings →",
      testJobBrowse: "Browse current live job postings →",
      applyTitle: "Apply",
      applyIntro: "Your profile info will be sent with this application. Add a short note + optional resume.",
      sendingAs: "Sending as",
      coverNote: "Cover note (optional)",
      coverPlaceholder: "Why you're a good fit...",
      resumeTitle: "Resume / Certifications (optional)",
      useProfileResume: "Include my resume",
      uploading: "Uploading…",
      attachDifferent: "Attach a different file",
      attachResume: "Attach resume",
      uploadResumeForApproval: "Upload resume for approval",
      resumeApprovalHint: "ChambaNOW reviews every resume. Yours is shared with the hirer only after it's approved.",
      resumeApprovedNote: "Approved — shared with the hirer.",
      resumePendingNote: "Pending ChambaNOW review — it'll be shared with the hirer once approved.",
      resumeRejectedNote: "Your last resume wasn't approved. Upload a new one for review.",
      resumeUploadedForReview: "Resume uploaded — we'll review it shortly.",
      resumeHint: "PDF only · Max 5 MB · Contact info is auto-removed for hirers.",
      resumeAttached: "Resume attached.",
      uploadFailed: "Upload failed",
      sending: "Sending...",
      sendApp: "SEND APPLICATION",
      sentSuccess: "Application sent. The hirer will respond in chat.",
      sendError: "Failed",
      badType: "Resumes must be a PDF.",
      tooBig: "File too large. Max 5 MB.",
    },
    pricing: {
      badge: "CHOOSE YOUR PLAN",
      heroTitle: "HIRE YOUR WAY",
      heroSubtitle: "New hirers get a full month of Hirer Plus free — no card required. Post unlimited jobs, then keep Plus for $29.99/mo — or grab a 48-Hour Job Pass to hire for a single job, extendable anytime before it ends.",
      passName: "48-Hour Job Pass",
      passPer: "/ 48h · one job",
      passDesc: "48 hours of hiring access for one job — search, message, and review applicants. Extend before it ends to keep going.",
      passFeatures: [
        "One job, 48 hours of hiring access",
        "Search, message & review applicants for that job",
        "Extend for 48 more hours anytime before it ends",
        "No subscription — upgrade to Hirer Plus anytime",
      ],
      passBtn: "GET 48-HOUR JOB PASS",
      plusName: "Hirer Plus",
      plusPer: "/ month",
      plusDesc: "For active hirers who need to fill multiple roles across day-labor, contract, and full-time work.",
      plusFeatures: [
        "Post UNLIMITED jobs for workers to apply to",
        "Contact & message every applicant",
        "Your own shareable Company Jobs page — embed it on your website",
        "Day labor, contract, temp-to-hire, permanent, full-time, per-diem",
        "Unlimited live availability access — no hiring pass needed",
        "Receive applications + custom application forms",
        "All industries: construction, landscape, cleaning, general labor & more",
        "Cancel anytime",
      ],
      recommended: "RECOMMENDED",
      manageSub: "MANAGE SUBSCRIPTION",
      goPlus: "GO PLUS — $29.99/MO",
      winbackTitle: "Welcome back — your next month is free 🎁",
      winbackBody: "Reactivate Hirer Plus below and you won't be charged for 30 days. A card is required so your benefits continue automatically after — cancel anytime.",
      hirersOnly: "Hirers only",
      failed: "Failed",
    },
  },
};

export const SKILL_TRANSLATIONS = {
  en: {
    construction: "Construction", landscaping: "Landscaping", moving: "Moving",
    painting: "Painting", plumbing: "Plumbing", electrical: "Electrical",
    carpentry: "Carpentry", cleaning: "Cleaning", roofing: "Roofing",
    drywall: "Drywall", demolition: "Demolition", flooring: "Flooring",
    concrete: "Concrete", general_labor: "General Labor", yard_work: "Yard Work",
    junk_removal: "Junk Removal", fence_install: "Fence Install", tile_work: "Tile Work",
    mechanical: "Mechanical",
  },
  es: {
    construction: "Construcción", landscaping: "Jardinería", moving: "Mudanza",
    painting: "Pintura", plumbing: "Plomería", electrical: "Eléctrico",
    carpentry: "Carpintería", cleaning: "Limpieza", roofing: "Techado",
    drywall: "Tablaroca", demolition: "Demolición", flooring: "Pisos",
    concrete: "Concreto", general_labor: "Trabajo General", yard_work: "Jardín",
    junk_removal: "Remoción", fence_install: "Cercas", tile_work: "Azulejo",
    mechanical: "Mecánico",
  },
};
